import { StepItemProps } from "@bsm/component";

export const useEmergencyContactStep = (): StepItemProps => {
    return {
        data: {
            title: "Emergency Contact",
            forms: [
                { type: "hidden", name: "id" },
                {
                    type: "input",
                    name: "lastName",
                    label: "Family Name",
                    required: true,
                },
                {
                    type: "input",
                    name: "firstName",
                    label: "First Name",
                    required: true,
                },
                {
                    type: "phone",
                    name: "phone",
                    label: "Phone Number",
                    required: true,
                },
            ],
            next: {
                label: "Save",
            },
            hideBack: true,
            graphQL: {
                entity: "user",
            },
        },
    };
};
